<template>
	<AccountFormField
		id="email-address"
		:label="$t('email_address')"
		:field="validation.Email"
	>
		<template #default="{ attrs }">
			<input
				v-model="email"
				v-bind="attrs"
				name="Email"
				type="email"
				autocomplete="email"
			/>
		</template>
	</AccountFormField>

	<AccountFormField
		id="firstname"
		:label="$t('first_name')"
		:field="validation.FirstName"
	>
		<template #default="{ attrs }">
			<input
				v-model="firstName"
				v-bind="attrs"
				name="FirstName"
				type="text"
				autocomplete="Firstname"
			/>
		</template>
	</AccountFormField>

	<AccountFormField
		id="lastname"
		:label="$t('last_name')"
		:field="validation.LastName"
	>
		<template #default="{ attrs }">
			<input
				v-model="lastName"
				v-bind="attrs"
				name="LastName"
				type="text"
				autocomplete="Lastname"
			/>
		</template>
	</AccountFormField>

	<AccountFormField
		id="password"
		:label="$t('password')"
		label-class="capitalize"
		:field="validation.Password"
	>
		<template #default="{ attrs }">
			<input
				v-model="password"
				v-bind="attrs"
				name="Password"
				type="password"
				autocomplete="password"
			/>
		</template>
	</AccountFormField>
</template>

<script setup lang="ts">
import type { ValidationField } from "~/types/account";

defineProps<{
	validation: {
		Email: ValidationField;
		FirstName: ValidationField;
		LastName: ValidationField;
		Password: ValidationField;
	};
}>();

const email = defineModel<string>("email", { required: true });
const firstName = defineModel<string>("firstName", { required: true });
const lastName = defineModel<string>("lastName", { required: true });
const password = defineModel<string>("password", { required: true });
</script>
